import React from 'react';
import styles from './styles/LegalPages.module.css';
import SEO from '../../components/SEO/SEO';
import Layout from '../../components/Layout/Layout';

export default function PrivacyPolicy() {
  // Mettre à jour le titre de la page
  React.useEffect(() => {
    document.title = 'Politique de Confidentialité - OV Hairstyle';
  }, []);

  return (
    <>
      <SEO
        title="Politique de Confidentialité | OV Hairstyle"
        description="Consultez notre politique de confidentialité pour comprendre comment nous protégeons vos données."
        url="https://ovhairstyle.com/privacy"
        image="https://ovhairstyle.com/images/og-image.jpg"
      />
      <Layout>
        <div className={styles.legalContainer}>
          <h1>POLITIQUE DE CONFIDENTIALITÉ</h1>
          <p className={styles.lastUpdated}>Dernière mise à jour: 12 mars 2026</p>

          <h2>1. INTRODUCTION</h2>
          <p>
            <strong>OV Hairstyle</strong> ("nous", "notre", "nos") exploite le site web <strong>ov-hairstyle.com</strong> et utilise <strong>WhatsApp Business</strong> pour
            communiquer avec nos clients. Cette politique de confidentialité explique comment nous
            collectons, utilisons, protégeons et gérons vos données personnelles.
          </p>
          <p>
            En utilisant nos services, y compris notre plateforme WhatsApp Business, vous acceptez
            les pratiques décrites dans cette politique. Si vous n'acceptez pas ces conditions,
            veuillez ne pas utiliser nos services.
          </p>

          <h2>2. DONNÉES COLLECTÉES</h2>
          <p>Nous collectons les données suivantes:</p>
          <ul>
            <li><strong>Numéro de téléphone WhatsApp:</strong> Pour vous contacter et vous envoyer des messages</li>
            <li><strong>Nom et prénom:</strong> Pour personnaliser nos communications</li>
            <li><strong>Demandes de rendez-vous:</strong> Dates, heures et services souhaités</li>
            <li><strong>Préférences de coiffure:</strong> Type de coupe, couleur, style</li>
            <li><strong>Historique de communication:</strong> Messages échangés via WhatsApp</li>
            <li><strong>Informations de paiement:</strong> Méthode de paiement utilisée (non stockée)</li>
            <li><strong>Adresse e-mail (optionnel):</strong> Pour les confirmations par e-mail</li>
          </ul>

          <h2>3. UTILISATION DE VOS DONNÉES</h2>
          <p>Vos données personnelles sont utilisées uniquement pour:</p>
          <ul>
            <li>Confirmer vos rendez-vous de coiffure</li>
            <li>Vous envoyer des rappels de rendez-vous (24h avant)</li>
            <li>Vous proposer nos services et offres spéciales</li>
            <li>Répondre à vos questions et demandes</li>
            <li>Améliorer la qualité de notre service client</li>
            <li>Vous envoyer des devis et factures</li>
            <li>Gérer les réclamations et litiges</li>
            <li>Respecter nos obligations légales</li>
          </ul>

          <h2>4. PLATEFORME WHATSAPP BUSINESS</h2>
          <h3>4.1 Comment nous utilisons WhatsApp</h3>
          <p>
            Nous utilisons <strong>WhatsApp Business</strong> pour:
          </p>
          <ul>
            <li>Confirmer vos rendez-vous</li>
            <li>Vous envoyer des rappels de RDV</li>
            <li>Vous proposer des devis et tarifs</li>
            <li>Répondre à vos questions</li>
            <li>Vous informer de nos promotions</li>
          </ul>

          <h3>4.2 Sécurité des messages</h3>
          <p>
            Les messages WhatsApp sont <strong>chiffrés end-to-end</strong> par WhatsApp Inc.
            Cela signifie que seul vous et OV Hairstyle pouvez lire vos messages. Même WhatsApp
            ne peut pas accéder au contenu de vos messages.
          </p>

          <h3>4.3 Consentement</h3>
          <p>
            En fournissant votre numéro WhatsApp, vous consentez à recevoir des messages de notre part.
            Vous pouvez vous désabonner à tout moment en répondant <strong>"STOP"</strong> à nos messages.
          </p>

          <h2>5. PARTAGE DE VOS DONNÉES</h2>
          <p>
            <strong>Nous ne vendons pas vos données.</strong> Vos données ne sont partagées que:
          </p>
          <ul>
            <li><strong>Avec WhatsApp Inc.:</strong> Pour l'envoi de messages (données chiffrées)</li>
            <li><strong>Avec Meta Platforms:</strong> Propriétaire de WhatsApp (données chiffrées)</li>
            <li><strong>Avec nos prestataires:</strong> Si nécessaire pour fournir nos services</li>
            <li><strong>Par obligation légale:</strong> Si une autorité nous y oblige</li>
          </ul>

          <h2>6. SÉCURITÉ DE VOS DONNÉES</h2>
          <p>Nous protégeons vos données avec:</p>
          <ul>
            <li><strong>Chiffrement SSL/TLS:</strong> Pour sécuriser les transferts de données</li>
            <li><strong>Accès restreint:</strong> Seul le personnel autorisé peut accéder aux données</li>
            <li><strong>Mots de passe forts:</strong> Pour tous les comptes administrateur</li>
            <li><strong>Authentification à deux facteurs:</strong> Pour les accès sensibles</li>
            <li><strong>Conformité RGPD:</strong> Respect des normes européennes</li>
          </ul>

          <h2>7. DURÉE DE CONSERVATION</h2>
          <p>
            Vos données sont conservées aussi longtemps que nécessaire pour:
          </p>
          <ul>
            <li>Fournir nos services</li>
            <li>Respecter nos obligations légales</li>
            <li>Résoudre les litiges</li>
          </ul>
          <p>
            Généralement, nous conservons vos données pendant <strong>3 ans</strong> après votre dernier
            rendez-vous. Vous pouvez demander la suppression de vos données à tout moment.
          </p>

          <h2>8. VOS DROITS</h2>
          <p>Vous avez les droits suivants concernant vos données:</p>
          <ul>
            <li><strong>Droit d'accès:</strong> Vous pouvez demander une copie de vos données</li>
            <li><strong>Droit de rectification:</strong> Vous pouvez corriger vos données inexactes</li>
            <li><strong>Droit à l'oubli:</strong> Vous pouvez demander la suppression de vos données</li>
            <li><strong>Droit à la portabilité:</strong> Vous pouvez récupérer vos données</li>
            <li><strong>Droit d'opposition:</strong> Vous pouvez refuser le traitement de vos données</li>
            <li><strong>Droit de limitation:</strong> Vous pouvez limiter le traitement de vos données</li>
          </ul>

          <h2>9. EXERCER VOS DROITS</h2>
          <p>
            Pour exercer l'un de ces droits, contactez-nous via:
          </p>
          <div className={styles.contactBox}>
            <p><strong>Email:</strong> contact@ov-hairstyle.com</p>
            <p><strong>WhatsApp:</strong> +243  980 356 686</p>
            <p><strong>Téléphone:</strong> +243 980 356 686</p>
            <p><strong>Adresse:</strong> Kinshasa, RD Congo</p>
          </div>
          <p>
            Nous répondrons à votre demande dans les <strong>30 jours</strong> suivant sa réception.
          </p>

          <h2>10. COOKIES ET TECHNOLOGIES DE SUIVI</h2>
          <p>
            Notre site web utilise des cookies pour:
          </p>
          <ul>
            <li>Mémoriser vos préférences</li>
            <li>Analyser le trafic du site</li>
            <li>Améliorer votre expérience utilisateur</li>
          </ul>
          <p>
            Vous pouvez désactiver les cookies dans les paramètres de votre navigateur.
            Cependant, cela peut affecter votre expérience sur notre site.
          </p>

          <h2>11. LIENS EXTERNES</h2>
          <p>
            Notre site peut contenir des liens vers des sites externes. Nous ne sommes pas responsables
            de la politique de confidentialité de ces sites. Nous vous recommandons de lire leur politique
            avant de partager vos données.
          </p>

          <h2>12. MODIFICATIONS DE CETTE POLITIQUE</h2>
          <p>
            Nous pouvons modifier cette politique de confidentialité à tout moment.
            Les modifications s'appliquent immédiatement après publication sur notre site.
          </p>
          <p>
            Pour les modifications importantes, nous vous notifierons par email ou via WhatsApp.
          </p>

          <h2>13. CONFORMITÉ LÉGALE</h2>
          <p>
            Cette politique de confidentialité est conforme à:
          </p>
          <ul>
            <li><strong>RGPD (Règlement Général sur la Protection des Données):</strong> Union Européenne</li>
            <li><strong>Loi Informatique et Libertés:</strong> France</li>
            <li><strong>Conditions d'utilisation de WhatsApp:</strong> Meta Platforms</li>
          </ul>

          <h2>14. CONTACT ET RÉCLAMATIONS</h2>
          <p>
            Si vous avez des questions concernant cette politique ou si vous souhaitez exercer vos droits:
          </p>
          <div className={styles.contactBox}>
            <p><strong>OV Hairstyle</strong></p>
            <p><strong>Email:</strong> contact@ov-hairstyle.com</p>
            <p><strong>WhatsApp:</strong> +243  980 356 686</p>
            <p><strong>Téléphone:</strong> +243  980 356 686</p>
            <p><strong>Adresse:</strong> Kinshasa, RD Congo</p>
          </div>

          <p>
            Vous avez également le droit de déposer une plainte auprès de l'autorité de protection
            des données de votre pays.
          </p>

          <h2>15. ACCEPTATION</h2>
          <p>
            En utilisant nos services, vous acceptez cette politique de confidentialité.
            Si vous n'acceptez pas ces conditions, veuillez cesser d'utiliser nos services.
          </p>
        </div>
      </Layout>
    </>
  );
}
